import { render, staticRenderFns } from "./HelpGroup.vue?vue&type=template&id=16d48ad6&scoped=true"
var script = {}
import style0 from "./HelpGroup.vue?vue&type=style&index=0&id=16d48ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d48ad6",
  null
  
)

export default component.exports